"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingModule = void 0;
const types_1 = require("../types");
/**
 * Represents a module for staking operations.
 */
class StakingModule {
    /**
     * Creates an instance of StakingModule.
     * @param axios - The AxiosInstance used for making HTTP requests.
     */
    constructor(axios) {
        this._axios = axios;
    }
    /**
     * Retrieves the available staking options.
     * @returns A Promise that resolves to an array of StakingOption objects.
     * @throws If an error occurs during the API request.
     */
    getStakingOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get('/v0/staking/staking_options');
                if (response.status === 200) {
                    return types_1.StakingOption.optionsFromJson(response.data);
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * A function that returns encoded data for the staking contract call.
     * @param stakeRequestBody - The request body for staking.
     * @returns A Promise that resolves to a StakeResponseBody object.
     * @throws If an error occurs during the API request.
     */
    stake(stakeRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.post('/v0/staking/stake', stakeRequestBody.toJson());
                if (response.status === 201) {
                    return types_1.StakeResponseBody.fromJson(response.data);
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * A function that returns encoded data for unstake contract call.
     * @param unstakeRequestBody - The request body for unstaking.
     * @returns A Promise that resolves to an UnstakeResponseBody object.
     * @throws If an error occurs during the API request.
     */
    unstake(unstakeRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.post('/v0/staking/unstake', unstakeRequestBody.toJson());
                if (response.status === 201) {
                    return types_1.UnstakeResponseBody.fromJson(response.data);
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Retrieves the staked tokens of a given smart wallet address on the platform.
     * @param walletAddress - The wallet address to retrieve staked tokens for.
     * @returns A Promise that resolves to a StakedTokenResponse object.
     * @throws If an error occurs during the API request.
     */
    getStakedTokens(walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get(`/v0/staking/staked_tokens/${walletAddress}`);
                if (response.status === 200) {
                    return types_1.StakedTokenResponse.fromJson(response.data);
                }
                throw response;
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.StakingModule = StakingModule;
